import { StageSchema } from '@common'
import { z } from 'zod'

const configJSONSchema = z.object({
  API_URL: z.string(),
  PAYSTATION_BASE_URL: z.string(),
  ADYEN_CLIENT_KEY: z.string(),
  TEST_CARDS: z.boolean(),
  GOOGLE_TAG_MANAGER_ID: z.string(),
  TRACKING_ENABLED: z.boolean(),
  COOKIE_CONSENT_ENABLED: z.boolean(),
  ADYEN_ENVIRONMENT: z.literal('test').or(z.literal('live')),
  APP_URL: z.string(),
  SENTRY_ENABLED: z.boolean(),
  SENTRY_DSN: z.string(),
  STAGE: StageSchema,
})

const configSchema = configJSONSchema.extend({
  BUILD_ID: z.string(),
})

let configJSON
if (process.env.NEXT_PUBLIC_STAGE === 'production') {
  configJSON = require('./production.json')
} else if (process.env.NEXT_PUBLIC_STAGE === 'staging') {
  configJSON = require('./staging.json')
} else if (process.env.NEXT_PUBLIC_STAGE === 'local-dev') {
  configJSON = require('./local-dev.json')
} else if (process.env.NEXT_PUBLIC_STAGE === 'test') {
  configJSON = require('./test.json')
} else {
  configJSON = require('./development.json')
}

export const config = configSchema.parse({
  ...configJSON,
  BUILD_ID: process.env.NEXT_PUBLIC_BUILD_ID,
})
